import WidgetType from '@/ecm/variables/WidgetType';

export default class WidgetSettings {
    constructor(widgetId, dto) {
        this.pageSize = '';
        this.showExternalValidation = '';
        this.chartType = '';
        this.periodicity = '';
        this.periodicityAmount = '';
        this.url = '';
        this.description = '';
        this.image = '';
        this.color = '';
        this.textColor = '';
        this.icon = '';
        this.bookmarkType = 0;
        this.text = '';
        this.target = '';
        this.widgetId = widgetId;
        this.widgetTitle = '';
        this.userSearchesToShow = [];

        if (dto) {

            if (this.widgetId == WidgetType.UserSearches) {
                this.pageSize = dto.PageSize;
                this.widgetTitle = dto.WidgetTitle;
                this.color = dto.Color || '#607d8b';
                this.userSearchesToShow = dto.UserSearchesToShow ? dto.UserSearchesToShow.split(',').map(function (id) { return { id: id + '', text: '' }; }) : [];
            }

            if (this.widgetId == WidgetType.Distributions) {
                this.pageSize = dto.PageSize;
                this.showExternalValidation = dto.ShowExternalValidation;
                this.widgetTitle = dto.WidgetTitle;
                this.color = dto.Color || '#607d8b';
            }

            if (this.widgetId == WidgetType.SearchHistory) {
                this.pageSize = dto.PageSize;
                this.widgetTitle = dto.WidgetTitle;
                this.color = dto.Color || '#0097a7';
                this.textColor = dto.TextColor || '#FFFFFFFF';
            }

            if (this.widgetId == WidgetType.UploadedDocumentsChart) {
                this.periodicity = dto.Periodicity;
                this.periodicityAmount = dto.PeriodicityAmount;
            }

            if (this.widgetId == WidgetType.Bookmark) {
                this.url = dto.Url;
                this.description = dto.Description;
                this.image = dto.Image;
                this.color = dto.Color || '#FFFFFFFF';
                this.textColor = dto.TextColor || '#000000FF';
                this.bookmarkType = parseInt(dto.BookmarkType || 0);
                this.icon = dto.Icon;
                this.target = dto.Target || '_blank';
            }
        }
    }

    toDto() {

        if (this.widgetId == WidgetType.UserSearches) {
            return {
                PageSize: this.pageSize,
                WidgetTitle: this.widgetTitle,
                UserSearchesToShow: this.userSearchesToShow.map(item => parseInt(item.id)).join(),
                Color: this.color
            };
        }

        if (this.widgetId == WidgetType.SearchHistory) {
            return {
                PageSize: this.pageSize,
                WidgetTitle: this.widgetTitle,
                Color: this.color,
                TextColor: this.textColor
            };
        }

        if (this.widgetId == WidgetType.Distributions) {
            return {
                PageSize: this.pageSize,
                ShowExternalValidation: this.showExternalValidation,
                WidgetTitle: this.widgetTitle,
                Color: this.color
            };
        }

        if (this.widgetId == WidgetType.UploadedDocumentsChart) {
            return {
                Periodicity: this.periodicity,
                PeriodicityAmount: this.periodicityAmount
            };
        }

        if (this.widgetId == WidgetType.Bookmark) {
            return {
                Url: this.url,
                Description: this.description,
                Image: this.image,
                Color: this.color,
                TextColor: this.textColor,
                BookmarkType: this.bookmarkType + '',
                Icon: this.icon,
                Target: this.target
            };
        }
    }
}